import { render, staticRenderFns } from "./OptionsButtons.vue?vue&type=template&id=6f2cd79f"
import script from "./OptionsButtons.vue?vue&type=script&lang=js"
export * from "./OptionsButtons.vue?vue&type=script&lang=js"
import style0 from "./OptionsButtons.vue?vue&type=style&index=0&id=6f2cd79f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2cd79f')) {
      api.createRecord('6f2cd79f', component.options)
    } else {
      api.reload('6f2cd79f', component.options)
    }
    module.hot.accept("./OptionsButtons.vue?vue&type=template&id=6f2cd79f", function () {
      api.rerender('6f2cd79f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/dialog/OptionsButtons.vue"
export default component.exports